module.exports = __webpack_public_path__ + "static/media/100.5ef80eed.gif";